var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-slide-progress-bar",attrs:{"id":"bottom-progress-bar"}},[_c('div',{staticClass:"slide-progress-bar",style:({backgroundColor: _vm.$store.state.slide.textColour, width: _vm.percentProgress})})])}
var staticRenderFns = []

export { render, staticRenderFns }